import { v4 as uuidv4 } from 'uuid';
import logo1 from '../../assets/img/brand/b1.png';
import logo10 from '../../assets/img/brand/b10.png';
import logo2 from '../../assets/img/brand/b2.png';
import logo3 from '../../assets/img/brand/b3.png';
import logo4 from '../../assets/img/brand/b4.png';
import logo5 from '../../assets/img/brand/b5.png';
import logo6 from '../../assets/img/brand/b6.png';
import logo7 from '../../assets/img/brand/b7.png';
import logo8 from '../../assets/img/brand/b8.png';
import logo9 from '../../assets/img/brand/b9.png';

const sponsorData = [
    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TVE9PQ==.jpg",
        url:"https://www.aatcc.org/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TWc9PQ==.jpg",
        url:"https://www.aatcc.org/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TXc9PQ==.jpg",
        url:"https://www.ufac.org/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TkE9PQ==.jpg",
        url:"http://www.gpoaccess.gov/cfr"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TlE9PQ==.jpg",
        url:"https://www.bsigroup.com/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/Tmc9PQ==.jpg",
        url:"https://www.sae.org/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/Tnc9PQ==.jpg",
        url:"http://www.aham.org/"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/T1E9PQ==.jpg",
        url:"https://www.iec.ch/homepage"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TVRFPQ==.jpg",
        url:"https://www.iso.org/home.html"
    },

    {
        id: uuidv4(),
        sponsorLogo: "https://smilesdahub.com/tf/apis/partners_images/TVRNPQ==.jpg",
        url:"http://www.sdc.org.uk/"
    },
];

export default sponsorData;
